import { NativeEventBus } from '../native/NativeEventBus';

export const setXtremepushId = (id: string): void => {
  callXtremepush('set', 'user_id', id);
};

export const xtremepushEvent = (eventName: string): void => {
  callXtremepush('event', eventName);
};

export const callXtremepush = (...args: unknown[]): void => {
  if (NativeEventBus.isNativeBridgeAvailable()) {
    return;
  }

  (window as unknown as Record<string, (...args: unknown[]) => void>).xtremepush(...args);
};
